export class GeoLocation {
    lat: number
    lng: number
}
